import React from 'react';
import { Provider } from 'react-redux';

import { createRoot } from 'react-dom/client';

import '@piwikpro/ui-components';
import '@piwikpro/ui-components/components.css';
import './index.css';

import App from './App';
import { store } from './store';

const rootContainer = document.getElementById('root')!;
const root = createRoot(rootContainer);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
